export default __webpack_public_path__ + "static/media/umbrella.4ab84a6d.svg";